import React from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import "./macbook.css";

const Macbook = () => {
  const navigate = useNavigate();

  const handleExploreClick = () => {
    // Navigate to Mac category with MacBook Pro subcategory
    navigate("/category/Mac?subcategory=MacBook%20Pro");
  };

  return (
    <section className="mac-wrapper">
      <Container>
        <Row className="align-items-center">

          {/* LEFT CONTENT */}
          <Col lg={6} className="mb-5 mb-lg-0">
            <motion.div
              initial={{ opacity: 0, x: -80 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 1 }}
              viewport={{ once: true }}
            >
              <h1 className="mac-title">
                MacBook Pro <br />
                <span>Speed of lightness.</span>
              </h1>

              <p className="mac-desc">
                MacBook Pro is the world's most powerful laptop for professionals.
                It delivers up to 22 hours of battery life. The M5 chip unlocks
                a whole new level of performance for work and play.
              </p>

              <motion.div
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
              >
                <Button 
                  className="explore-btn"
                  onClick={handleExploreClick}
                >
                  Explore MacBook Pro →
                </Button>
              </motion.div>
            </motion.div>
          </Col>

          {/* RIGHT IMAGE */}
          <Col lg={6} className="text-center">
            <motion.img
              src="./images/macbook.png"
              alt="Macbook Pro"
              className="mac-image"
              initial={{ opacity: 0, scale: 0.9, y: 50 }}
              whileInView={{ opacity: 1, scale: 1, y: 0 }}
              transition={{ duration: 1 }}
              viewport={{ once: true }}
              animate={{ y: [0, -15, 0] }}
            />
          </Col>

        </Row>
      </Container>
    </section>
  );
};

export default Macbook;